// import external dependencies
import 'jquery';

// import then needed Font Awesome functionality
//import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
//import { faHouzz, faFacebook, faTwitter, faGooglePlusG, faLinkedin, faPinterest, faInstagram } from '@fortawesome/free-brands-svg-icons';
//import { faAngleDown, faPaperPlane, faRuler, faCut, faSpinner, faSearch, faGlobe, faPhone, faEnvelope, faCircle, faEnvelopeOpen} from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
//library.add(faHouzz, faPaperPlane, faRuler, faCut, faSpinner, faCircle, faEnvelope, faSearch, faGlobe, faPhone, faFacebook, faTwitter, faGooglePlusG, faLinkedin, faPinterest, faInstagram, faAngleDown, faEnvelopeOpen);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
//dom.watch();


// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js